<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <b-img fluid :src="sideImg" />
        </b-link>

        <b-card-title class="mb-1">
          ลืมรหัสผ่าน
        </b-card-title>
        <!-- <b-card-text class="mb-2">
          เพื่อเข้าร่วมเป็นส่วนหนึ่งของตลาดนัด และขายสินค้าต่างๆ จากร้านของคุณได้เลย
        </b-card-text> -->

        <!-- form -->
        <validation-observer ref="registerForm">
          <b-form
            class="auth-register-form mt-2"
            @submit.prevent="validationForm"
          >
            <b-form-group label="เบอร์โทรศัพท์" label-for="phone">
              <validation-provider
                #default="{ errors }"
                name="Phone"
                rules="required"
              >
                <b-form-input
                  id="phone"
                  v-model="phone"
                  placeholder="หมายเลขโทรศัพท์"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button variant="primary" block type="submit">
              ต่อไป
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <span>หากมีบัญชีผู้ใช้แล้ว คุณสามารถ </span>
          <b-link :to="{ name: 'auth-login' }" style="color: #0059de;">
            <span>เข้าสู่ระบบ</span>
          </b-link>
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BForm,
  BImg,
  BButton,
  BFormInput,
  BFormGroup,
} from "bootstrap-vue";
import { required } from "@validations";
import store from "@/store/index";
import { onUnmounted } from "@vue/composition-api";
import authenStoreModule from "./authenStoreModule";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    // BSV
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BImg,
    // validations
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      sideImg: require("@/assets/images/logo/logo.png"),
      phone: "",
      // validation rules
      required,
    };
  },
  setup() {
    // Register module
    if (!store.hasModule("authen"))
      store.registerModule("authen", authenStoreModule);

    // // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule('authen')) store.unregisterModule('authen')
    // })

    return {};
  },
  methods: {
    validationForm() {
      this.$refs.registerForm.validate().then((success) => {
        if (success) {
          const registerModel = { phone: this.phone };

          console.log("registerModel", registerModel);

          this.$router.push({
            name: "auth-verify-otp-password",
            params: { phone: this.phone },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
